import { isAppInstalled, getAppStoreVersion } from "@/src/utils/appStoreUtils.js";
import { appStoreCodes } from "@/src/constants/appConstants.js";

export const checkWhatsAppEnabled = async (store) => {
  const appStoreVersion = getAppStoreVersion(store);
  
  if (appStoreVersion === "v1") {
    return localStorage.getItem("sequences_whatsapp_enabled") === "true";
  }
  
  return await isAppInstalled(appStoreCodes.WHATSAPP);
};

export const getBlocksEnabledStatus = () => {
  return {
    email: localStorage.getItem("sequences_email_blocks") === "true",
    linkedin: localStorage.getItem("linkedin_blocks") === "true",
    mrAgent: localStorage.getItem("sequences_mr_agent_blocks") === "true",
    qualificationAgent:
      localStorage.getItem("sequences_qualification_agent_blocks") === "true",
    threadingAgent:
      localStorage.getItem("sequences_threading_agent_blocks") === "true",
    actionBlocks: localStorage.getItem("sequences_action_blocks") === "true",
    whatsappEnabled: localStorage.getItem("sequences_whatsapp_enabled") === "true",
  };
};

export const getStepOptionsActiveState = () => {
  const blocksStatus = getBlocksEnabledStatus();

  const aiEnabled = Object.values(blocksStatus).some((status) => status);

  return {
    ai: aiEnabled,
    automated: true,
    manual: true,
  };
};


export const getFeatureBlockStatus = async (store) => {
  const blocksStatus = getBlocksEnabledStatus();

  const isWhatsAppEnabledForVersion = await checkWhatsAppEnabled(store);

  const blockStatus = {
    ai_email_agent: { active: false, disabled: true },
    ai_linkedin_message_agent: { active: false, disabled: true },
    ai_linkedin_inmail_agent: { active: false, disabled: true },
    linkedin_message: { active: false, disabled: true },
    linkedin_inmail: { active: false, disabled: true },
    linkedin_connection_request: { active: false, disabled: true },
    market_research_agent: { active: false, disabled: true },
    qualification_agent: { active: false, disabled: true },
    multi_threading_agent: { active: false, disabled: true },
    next_best_action: { active: false, disabled: true },
    whatsapp_message: { active: false, disabled: true }, // Automated WhatsApp - hidden by default
    whatsapp_message_task: { active: false, disabled: true }, // Manual WhatsApp task - hidden by default
  };

  if (blocksStatus.email) {
    blockStatus["ai_email_agent"] = { active: true, disabled: false };
  }

  if (blocksStatus.linkedin) {
    blockStatus["ai_linkedin_message_agent"] = {
      active: true,
      disabled: false,
    };
    blockStatus["ai_linkedin_inmail_agent"] = { active: true, disabled: false };
    blockStatus["linkedin_message"] = { active: true, disabled: false };
    blockStatus["linkedin_inmail"] = { active: true, disabled: false };
    blockStatus["linkedin_connection_request"] = { active: true, disabled: false };
  }

  if (blocksStatus.mrAgent) {
    blockStatus["market_research_agent"] = { active: true, disabled: false };
  }

  if (blocksStatus.qualificationAgent) {
    blockStatus["qualification_agent"] = { active: true, disabled: false };
  }

  if (isWhatsAppEnabledForVersion)  {
    blockStatus["whatsapp_message"] = { active: true, disabled: false };
    blockStatus["whatsapp_message_task"] = { active: true, disabled: false };
  }

  if (blocksStatus.threadingAgent) {
    blockStatus["multi_threading_agent"] = { active: true, disabled: false };
  }

  if (blocksStatus.actionBlocks) {
    blockStatus["next_best_action"] = { active: true, disabled: false };
  }

  return blockStatus;
};
